import { LOGOUT_SUCCESS } from "../../utils/constants";
import { SAVE_USER_INFO } from "../../utils/constants/redux";

const initialState = {
  data: null,
  loaded: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_USER_INFO:
      return {
        data: action.payload,
        loaded: true,
      };

    case LOGOUT_SUCCESS:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
